module.exports = __webpack_public_path__ + "img/login.ca5c41cc.png";